import React, { useCallback } from 'react';
import * as smartMoneyMetadataService from '../../services/smartMoneyService';

const useSmartMoneyMetadata = () => {

    const findSmartMoney = useCallback(async (address: string, chainId: number) => {
        try {
            const response = await smartMoneyMetadataService.findSmartMoneyMetadata(address, chainId);
            const roleData = response.data;
            return roleData;
        } catch (error) {
            console.error("Failed to fetch smart money:", error);
            throw error; 
        }
    }, []);

    const uploadCSV = useCallback(async (formData: FormData) => {
        try {
            const response = await smartMoneyMetadataService.uploadCSVFile(formData);
            return response.data;
        } catch (error) {
            console.error("Upload CSV failed:", error);
            throw error;
        }
    }, []);

    return {
        findSmartMoney,
        uploadCSV
    };
};

export default useSmartMoneyMetadata;
